export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: "热点内幕的内容主要来自哪里？",
    answer:
      "内容主要来自长期合作的知情人与行业内部人士提供的线索，同时结合公开报道、公告与工商信息进行交叉比对。我们不会发布只有单一来源、且无法通过公开信息印证的关键信息。",
  },
  {
    question: "网站上的爆料会标明信源吗？",
    answer:
      "会标注信源类型与可信度等级，但出于保护提供线索者的考虑，通常只披露其所在方向或岗位属性，例如「前项目统筹」「区域招商负责人」，而不会公开其真实身份。",
  },
  {
    question: "多久更新一次？",
    answer:
      "日常状态下每天更新若干条，遇到重大事件会启动持续跟进。已发布的爆料如果出现新的进展，我们会直接在同一篇内容里补充更新，而不是另开一篇重复标题。",
  },
  {
    question: "如何判断一条爆料是否可靠？",
    answer:
      "建议先看文中的时间线是否完整、关键节点是否具体，再看是否有可查证的公开信息作为支撑。对标注为「待确认」的部分请保持谨慎，那代表我们尚未完成交叉验证。",
  },
  {
    question: "可以提供爆料线索吗？",
    answer:
      "可以。你可以通过站内提供的邮箱发送线索，建议附上事件发生的时间、地点与可核实的细节。我们会对提供者的信息严格保密，并在核实后再决定是否发布。",
  },
  {
    question: "内容涉及的主体名称为什么不写全？",
    answer:
      "对于尚未有权威结论的事件，我们倾向于使用泛指或化名描述，以避免在事实未明时对具体主体造成不当影响。当信息得到多方确认后，表述会相应调整。",
  },
];